// import { faChevronDown as lightChevronDown } from "@jewlr/pro-light-svg-icons/faChevronDown"
// import { faChevronUp as lightChevronUp } from "@jewlr/pro-light-svg-icons/faChevronUp"
import { FocusScope } from "@react-aria/focus"
import PropTypes from "prop-types"
// import { useState } from "react"
import { connect } from "react-redux"

import { updateChoice } from "areas/product/store/actions"
// import Button from "components/ui/button"
// import Expand from "components/ui/expand"
// import FontAwesomeIcon from "components/ui/font-awesome-icon"
import {
  ChoiceOption,
  GradientContainer,
  OptionTitle,
  OptionPrice,
  OptionsSlider,
  OptionImage,
} from "areas/product/wizard-options/components"
import { to_currency } from "helpers/number"
import { imageLookup } from "helpers/product/image-lookup"
import { useNavigation } from "helpers/use-navigation"

const ChoiceOptions = ({ asv, handleClick, selected }) => {
  const keyboardProps = useNavigation({ direction: "horizontal" })
  return (
    <ChoiceOption
      aria-checked={selected}
      data-is-option="true"
      data-is-selected={selected}
      onClick={handleClick}
      role="radio"
      tabIndex={selected ? 0 : -1}
      {...keyboardProps}
    >
      <OptionImage
        alt={asv.title}
        sizes="40px"
        src={imageLookup("as", asv.imageKey).x2}
        srcSet={
          imageLookup("as", asv.imageKey).x1 +
          " 1x," +
          imageLookup("as", asv.imageKey).x2 +
          " 2x"
        }
        title={asv.title}
      />

      <OptionTitle>{asv.title}</OptionTitle>
      <OptionPrice>{to_currency(asv.price)}</OptionPrice>
    </ChoiceOption>
  )
}

ChoiceOptions.propTypes = {
  asv: PropTypes.object,
  handleClick: PropTypes.func,
  selected: PropTypes.bool,
}

const InternalAccentOptions = ({ data, selectedValue, setChoice }) => {
  // const [showDetail, setshowDetail] = useState(false)
  // const [accentDetail, setAccentDetail] = useState(data.options[0])

  return (
    <GradientContainer>
      <FocusScope restoreFocus>
        <OptionsSlider
          aria-label={`${data.heading.title} Options`}
          className="tablet:justify-center"
          data-slider="true"
          role="radiogroup"
        >
          {data.options.map((asv) => (
            <ChoiceOptions
              asv={asv}
              data={data}
              handleClick={(e) => {
                setChoice(data.pref, asv, e)
                // setAccentDetail(asv)
              }}
              key={`sliderAccentOption-${asv.value}`}
              selected={selectedValue === asv.value}
            />
          ))}
        </OptionsSlider>
      </FocusScope>
      {/* Notes for Dev: */}
      {/* Comment out Accent Stone Expand temporarily as we dont' have dynamic details for each stone */}
      {/* <div className="mb-24">
        <Button
          className="text-primary text-11 tracking-half leading-13 mb-8 font-medium"
          onClick={() => setshowDetail(!showDetail)}
          text
        >
          About {accentDetail.title}{" "}
          <FontAwesomeIcon
            className="text-primary text-8 ml-5"
            icon={showDetail ? lightChevronUp : lightChevronDown}
          />
        </Button>
        <Expand show={showDetail}>
          <p className="text-grey-35 text-12 tracking-half leading-14 font-medium">
            Cubic Zirconia is a semi-precious stone that are used as diamond
            simulants.What distinguishes it from the others is that its cut
            gives it a shiny semblance close to diamond when it is subject to
            light.
          </p>
        </Expand>
      </div> */}
    </GradientContainer>
  )
}

const getSelectedValue = (state, ownprops) => {
  if (typeof state.choices[ownprops.pref] === "undefined") {
    return ""
  } else {
    return state.choices[ownprops.pref].value
  }
}

const getData = (state, ownProps) => {
  return state.wizard.data[ownProps.pref]
}
const mapStateToProps = (state, ownProps) => {
  return {
    data: getData(state, ownProps),
    selectedValue: getSelectedValue(state, ownProps),
  }
}
const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    setChoice: (pref, data) => {
      dispatch(updateChoice(pref, data, true))
      try {
        if (typeof ownProps.callback !== "undefined" && ownProps.callback) {
          ownProps.callback()
        }
      } catch (error) {
        console.log("CALLBACK ERROR:", error)
      }
    },
  }
}

InternalAccentOptions.propTypes = {
  data: PropTypes.object,
  selectedValue: PropTypes.string,
  setChoice: PropTypes.func,
}

const AccentOptions = connect(
  mapStateToProps,
  mapDispatchToProps
)(InternalAccentOptions)

export default AccentOptions
